module.exports = __webpack_public_path__ + "static/media/ButtonPlus.ff3be152.png";